<template>
  <!--主要人员-->
  <TableView
    :columns="columns"
    :data="data"
    :pagination="false"
    :loading="loading"
    :bordered="bordered"
    :rowKey="rowKey"
  ></TableView>
</template>
<script>
import { TableView } from '@/lxfintech-fe-components'
export default {
  props: ['data'],
  components: { TableView },
  data() {
    return {
      rowKey: 'id',
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return index + 1
          },
        },
        {
          title: '姓名',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '职务',
          dataIndex: 'position',
          key: 'position',
        },
      ],
      loading: false,
      bordered: true,
    }
  },
  methods: {},
}
</script>
